var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rm-search-panel"},[_c('div',{staticClass:"rm-search-panel__form"},[_vm._t("default")],2),(_vm.$slots.actions)?_c('div',{staticClass:"rm-search-panel__actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }